// extracted by mini-css-extract-plugin
var _1 = "EmailCopyToEntityModalFields-modulecontainer__ZvFKp FormFieldsContainer-moduleFormFieldsContainer__u1JJu";
export { _1 as "container" }
